import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component'
import { ImCancelCircle } from "react-icons/im";

import axios from 'axios'
import ModalMyTrainingDays from './ModalMyTrainingDays'
import { useParams } from 'react-router-dom'
import Cancel from './Cancel';
import { FaDownload } from 'react-icons/fa';
const GET_URL = 'dashboard/member/my_qualification_day'
const GET_URLDELETE = 'dashboard/member/detach_qualification_day'
const MyTrainingDays = () => {
    const { corseId } = useParams();


   
    const [fetchData, setFetchData] = useState([])
    const [loading, setloading] = useState(true)
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1)
    const [modalIsOpen, setModalIsOpen] = useState("");
    const [id, setId] = useState("");
 
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2); // Ensure 2 digits for month
        const day = ('0' + date.getDate()).slice(-2); // Ensure 2 digits for day
        return `${day}/${month}/${year}`;
    };
    
    
    
    const getTrainingDays = async (page) => {
        setloading(true)
        await axios.get(GET_URL, {
            params: {
                
                "page": page
                , "size": perPage,


            }
        })
            .then(response => {
                if (response.status == 200) {
                    setFetchData(response?.data)
                    // setdataForfilterScrach(response?.data)
                    // setTotalRows("");
                }
            })
        setloading(false)

    }
    useEffect(() => {
        getTrainingDays(currentPage - 1)
        if(corseId)
            {
                setModalIsOpen("OPEN") 
            }
    }, [currentPage, perPage])

    const handlePerRowsChange = async (newPerPage) => {
        setPerPage(newPerPage);

    }
    const handlePageChange = (page) => {
        // fetchUsers(page);
        // getData(page);
        setCurrentPage(page);
    };
    const handleColse = () => {
        setModalIsOpen("")
    }
    const columns = [
        {
            name: "פעולות",

            // cell: row => row?.mySelfQualificationDto?.statusQualification?.id=="5"&&<div className='w-full'>
            cell: row => <div className='w-full flex justify-center items-center'>
                {/* <a title="ייצא תעודה"  className='p-0'
                        href={`https://archivebureau.s3.eu-west-3.amazonaws.com/${row.imgCertificate}`}
             ><button className=' border border-gray-500 p-1 opacity-25 hover:opacity-100' ><MdAssignmentReturned /></button></a> */}
                {/* <button title="מחיקה" className=' border border-gray-500 ml-1 p-1 opacity-25 hover:opacity-100' onClick={() => {
                    // setId(row)
                    // setModalIsOpen("Delete")
                }}><MdAssignment /></button> */}
                
                   <a
                   title="הורדת תעודה"
                      href={row?.mySelfQualificationDto?.statusQualification?.statusDescription === "הסתיים" && row?.reportCertificateNumberDto ? row?.reportCertificateNumberDto?.linkUrl : "#"}
                      download
                      className={`flex items-center gap-2 px-4 py-2 rounded transition ${
                        row?.mySelfQualificationDto?.statusQualification?.statusDescription === "הסתיים" && row?.reportCertificateNumberDto ? "bg-blue-600 text-white hover:bg-blue-800" : "bg-gray-300 text-gray-500 cursor-not-allowed"
                      }`}
                    //   onClick={(e) => {
                    //     if (!(row.mySelfQualificationDto?.statusQualification?.statusDescription === "הסתיים" && row.reportCertificateNumberDto?.linkUrl)) e.preventDefault();
                    //     // console.log(`https://archivebureau.s3.eu-west-3.amazonaws.com/${row?.reportCertificateNumberDto?.linkUrl}`)
                    //   }}
                    >
                      <FaDownload />
                      {/* הורדת תעודה */}
                    </a>
                {
                // row?.mySelfQualificationDto?.statusQualification?.id=="5"&&row?.isCanDetach&&
                // !row?.mySelfQualificationDto?.isCanDetach?
                <button title="ביטול קורס" className='  ml-1 p-1 disabled:opacity-25 hover:opacity-70' 
                disabled={!(row?.isCanDetach)} onClick={() => {
                    setId(row?.mySelfQualificationDto)
                    setModalIsOpen("Delete")
                }}><ImCancelCircle size={16} /></button>}
                {/* <button className=' border border-gray-500 p-1  ml-1 opacity-25 hover:opacity-100' onClick={() => {
                // setnamecalss(row?.description)
                // setAction("edit")
                setId(row)
                setModalIsOpen("Edit")
            }
            }><BsPencil /></button> */}
               
            </div>,


            style: {
                fontSize: '10px',
                justifyContent: 'center',



                // padding: '2px'
                // width: '100%'
            },
            grow: 1,


        },
        {
            name: "תעודה",
            // grow: 2,
            cell: (row) => row?.reportCertificateNumberDto?.number,
            style: {
                fontSize: '9px',
                justifyContent: 'center',
                // width: '100px'
            },
             
        },
            {
            name: "קבלה",
            cell: (row) => (
                <div className="flex items-center justify-center gap-2 w-full">
                    <span className="text-gray-700 text-[9px] min-w-[40px] text-right">
                        {row?.numberReceipt || ""}
                    </span>
                    <a
                        href={row?.urlReceipt || "#"}
                        target="_blank"
                        rel="noreferrer"
                        title="הורדת קבלה"
                        className={`flex items-center gap-2 px-4 py-2 rounded transition ${
                            row?.urlReceipt ? "bg-green-600 text-white hover:bg-green-800" : "bg-gray-300 text-gray-500 cursor-not-allowed pointer-events-none"
                        }`}
                    >
                        <FaDownload />
                    </a>
                </div>
            ),
            style: {
                fontSize: '9px',
                justifyContent: 'center',
            }
        },

        {
            name: "סטטוס הכשירות",
            // grow: 3,
            selector: (row) => row?.mySelfQualificationDto?.statusQualification?.statusDescription,
            style: {
                fontSize: '10px',
                justifyContent: 'center',
                // width: '100px'
            },
             
        },
        // {
        //     name: "תאריך הרשמה",
        //     grow: 1,
        //     selector: (row) => formatDate(row?.dateRegister),
        //     style: {
        //         fontSize: '10px',
        //         justifyContent: 'center',
        //         // width: '500px'
        //     },
        // 
        // },
        {
            name: "שם המדריך",
            // grow: 3,
            selector: (row) => row?.mySelfQualificationDto?.instructor?.frame_manager,
            style: {
                fontSize: '9px',
                justifyContent: 'center',
                // width: '100px'
            },
             
        },
        {
            name: "תאריך",
            // grow: 3,
            selector: (row) => row?.mySelfQualificationDto?.startDate? formatDate(row?.mySelfQualificationDto?.startDate):"",
            style: {
                fontSize: '9px',
                justifyContent: 'center',
                // width: '100px'
            },
             
        },
        {
            name: "שם יום הכשירות",
            // grow: 3,
            cell: (row) =>  row?.mySelfQualificationDto?.name,
            style: {
                fontSize: '9px',
                justifyContent: 'center',
                // width: '100px'
            },
             
        },


        {
            name: "מספר יום הכשירות",
            // grow: 3,
            cell: (row) => row?.mySelfQualificationDto?.number,
            style: {
                fontSize: '9px',
                justifyContent: 'center',
                // width: '100px'
            },
             


        },
        {
            name: "אשכול",
            // grow: 3,
            selector: (row) => row?.mySelfQualificationDto?.cluster?.name,
            style: {
                fontSize: '9px',
                justifyContent: 'center',
                // width: '100px'
            },
             


        },
        {
            name: "מספר אשכול",
            // grow: 3,
            cell: (row) => row?.mySelfQualificationDto?.cluster?.number,
            style: {
                fontSize: '9px',
                justifyContent: 'center',
                // width: '100px'
            },
             


        },



    ];



    const customStyles = {
        header: {
            style: {

                justifyContent: 'center',

            },
        },
        id: {
            style: {
                '&:2': { backgroundColor: '#EEEEEE' },
            }
        },
        headRow: {
            style: {
                justifyContent: 'center',
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                // borderTopColor: defaultThemes.default.divider.default,
            },
        },
        headCells: {
            style: {

                // whiteSpace: 'normal',
                // overflow: 'visible',
                // textOverflow: 'clip',
                // maxWidth: 'none', // Allow headers to expand as needed
                // padding: '10px'
                // ,
                fontSize: '10px',
                justifyContent: 'center',
                borderRightStyle: 'solid',
                borderRightWidth: '1px',
                paddingLeft: '0px',
                paddingRight: '0px'
                // borderRightColor: defaultThemes.default.divider.default,

            },
        },
        cells: {
            style: {
                '&:not(:last-of-type)': {
                    // padding: '10px'
                    // ,
                    //       paddingLeft:'0px',
                    // paddingRight:'0px',
                    //     borderRightStyle: 'solid',
                    //     borderRightWidth: '1px',
                    // borderRightColor: defaultThemes.default.divider.default,
                },
                borderRightStyle: 'solid',
                borderRightWidth: '1px',
                paddingLeft: '0px',
                paddingRight: '0px',
            },
        },
        rows: {
            style: {
                backgroundColor: '#FFFFFF',
                '&:active': {
                    backgroundColor: '#EEEEEE',
                },
            },
        },
    }



    const handleDetele = async () => {

        await axios.get(`${GET_URLDELETE}/${id?.id}`).then(response => {
            if (response.status == 200) {
                handleColse()
                getTrainingDays()
                console.log("ok")
            }
            else {
                console.log("error")
            }
        })
    }





  return (
<div className='bg-white p-2'>
<div className='bg-[#0d406b] text-right text-white font-semibold text-[20px] p-2 font-sans grid grid-cols-2 rounded-t-lg border '>
<div className='flex justify-end'>
<button className='bg-[#1e8e2b] border border-[#1a7925] text-white w-fit h-fit flex justify-self-end self-center p-2 px-3 rounded-lg'
 onClick={()=>{setModalIsOpen("OPEN")}}>
  חדש+
</button>

</div>
<p>ימי הכשרות שלי</p>


</div>
{(modalIsOpen=="OPEN")&&<ModalMyTrainingDays corseId={corseId} handleColse={handleColse} setModalIsOpen={setModalIsOpen}  getTrainingDaysMain={()=>getTrainingDays(currentPage - 1)}></ModalMyTrainingDays>}
<DataTable columns={columns} data={fetchData} pagination customStyles={customStyles}
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                progressPending={loading} className='border'
                progressComponent={<></>}
                noDataComponent={<div className='p-6 text-[#0d406b] text-sm font-semibold'>עדיין לא נרשמת לאף יום כשירות</div>}
                >
            </DataTable>
{(modalIsOpen=="Delete")&&<Cancel handleColse={handleColse} handleDetele={handleDetele} ></Cancel>}

</div>
  )
}

export default MyTrainingDays